<template>
  <el-dialog style="max-height: 80%;top: 10%;" width="620px" :title="'付款记录-订单号：'+form.code" :visible.sync="form.useDetailsDialog" :append-to-body="true">
    <div class="useDetails">
      <ul>
        <li v-for="(v,n) in useDetailsList" :key="n">
          <div class="liLeft">{{ v.createTime }}</div>
          <div class="liMiddle">
            <span v-if="n == 0"><i class="iconOne"></i></span>
            <samp v-else></samp>
          </div>
          <div v-if="useDetailsList.length != n+1" class="label"></div>
          <div class="liRight">
            <p v-if="v.bookType==0">付款金额：￥{{ v.payAmount }}<span>({{ v.payTypeName }})</span></p>
            <p v-else>定金金额：￥{{ v.payAmount }}<span>({{ v.payTypeName }})</span></p>
            <p v-if="v.payType">支付方式：{{ v.payTypeName||'--' }}</p>
            <p v-if="v.bookType==0">剩余款项：￥{{ v.balance }}</p>
            <p v-if="v.bookType==0">操作人：{{ v.operatorName || '--' }}</p>
          </div>
        </li>
        <div v-if="useDetailsList.length == 0" class="noneDetailsData">
          <h4 class="i">!</h4>
          <h6>暂无数据</h6>
        </div>
      </ul>
    </div>
  </el-dialog>
</template>
<script>
import { getPartPayList } from '../api';

export default {
  data() {
    return {
      useDetailsList: [],
      form: {
        useDetailsDialog: false,
        code: ''
      },
    };
  },
  // 监听会员ID的变化
  watch: {
    'form.useDetailsDialog': function (val) {
      if (val) this.detailsData();
    }
  },
  mounted() {
    const vm = this;
    vm.$emit('payRecord', vm.form);
  },
  methods: {
    // 付款记录详情
    detailsData() {
      const data = {
        mainId: window.sessionStorage.mainId,
        orderCode: this.form.code,
        orderType: this.form.orderType
      };
      getPartPayList(data).then((res) => {
        this.useDetailsList = res.data;
      });
    },
  }
};
</script>

<style lang="less" scoped>
.useDetails {
  min-height: 300px;
  ul {
    list-style-type: none;
    .noneDetailsData {
      padding: 100px 0 0 0;
      .i {
        display: block;
        text-align: center;
        width: 22px;
        height: 22px;
        line-height: 22px;
        font-size: 17px;
        color: #cecece;
        border: 2px solid #cecece;
        margin: 0 auto;
        border-radius: 50%;
      }
      h6 {
        color: #999;
        font-size: 14px;
        text-align: center;
        height: 40px;
        line-height: 40px;
      }
    }
    li {
      display: flex;
      line-height: 20px;
      .liLeft {
        padding-top: 3px;
        width: 90px;
        font-size: 14px;
        line-height: 16px;
        color: #333;
      }
      .liMiddle {
        width: 31px;
        padding-top: 5px;
        position: relative;
        z-index: 1;
        span {
          display: block;
          width: 17px;
          height: 17px;
          border-radius: 50%;
          background-color: #fff;
          border: 1px solid #d8dce5;
          position: relative;
          margin-left: -1px;
          margin-top: -3px;
          .iconOne {
            display: block;
            width: 11px;
            height: 11px;
            border-radius: 50%;
            margin: 3px;
            background-color: #d8dce5;
          }
        }
        samp {
          display: block;
          width: 11px;
          height: 11px;
          margin: 0 3px;
          border-radius: 50%;
          background-color: #d8dce5;
        }
      }
      .label {
        border-left: 1px solid #d8dce5;
        position: relative;
        top: 6px;
        left: -23px;
        z-index: 0;
      }
      .liRight {
        flex: 1;
        padding-bottom: 30px;
        p {
          font-size: 14px;
          color: #333;
          min-height: 24px;
          line-height: 24px;
          span {
            padding-left: 10px;
          }
        }
        h5 {
          font-size: 14px;
          color: #333;
          min-height: 24px;
          line-height: 24px;
          span {
            padding-right: 20px;
          }
        }
      }
    }
  }
}
</style>
